import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import AppData from 'app_data';
import Utils from 'utils/common_utils';
import { DefaultSpinner, NoData } from 'components';
import LocationScopeGate from 'hooks/useAdminGroup/LocationScopeGate';
import { useScopedApiFilters } from 'hooks/useAdminGroup/useScopedApiFilters';


class QualityPanelItem extends Component {
  static propTypes = {
    /** The label of the panel */
    label: PropTypes.string,
    /** The value to be displayed on the panel */
    value: PropTypes.number,
    /** Optional label for the bottom part of the panel. */
    percentLabel: PropTypes.string,
    /** Optional percentage for the bottom part of the panel/ */
    percentValue: PropTypes.number,
  };

  static defaultProps = {
    label: '',
    value: 0,
    percentLabel: '',
    percentValue: 0.0,
  };

  render() {
    return (
      <div className="panel-item">
        <div className="panel-title">{this.props.label}</div>
        <div className="panel-percent">
          {Utils.numberWithCommas(this.props.value)}

          {this.props.percentLabel !== null ?
          <div className="panel-number">
            {this.props.percentLabel} <span>{this.props.percentValue}%</span>
          </div>
        : null}
        </div>
      </div>
    );
  }
}


class QualityTrendPanels extends React.Component {
  static propTypes = {
    /** The time period being represented by the panels */
    timeRange: PropTypes.object,
    /** Breadcrumb-scoped filters (scope_locations) merged in by the wrapper */
    scopedFilters: PropTypes.object,
  };

  state = {
    panelData: [],
  };

  // Monotonic id of the latest FIRED request. getQualityPanelData has no
  // cancellation (raw axios client), so overlapping requests can land out of
  // order; only the newest may commit.
  fetchSeq = 0;

  componentDidMount() {
    this.updateData(this.props);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.timeRange, this.props.timeRange) ||
        !_.isEqual(prevProps.scopedFilters, this.props.scopedFilters)) {
      this.updateData(this.props);
    }
  }

  updateData = (props) => {
    const params = {
      time_range: props.timeRange
    };

    // Only add the key when there is something to send, so the payload stays
    // byte-identical to the pre-LBA one when no scope applies.
    if (!_.isEmpty(props.scopedFilters)) {
      params.filters = props.scopedFilters;
    }

    const seq = ++this.fetchSeq;
    AppData.getQualityPanelData(params)
      .then((response) => {
        // A newer request has fired since (scope or time range changed);
        // this response is stale. Drop it.
        if (seq !== this.fetchSeq) {
          return;
        }
        this.setState({ panelData: response.data });
      });
  };

  render() {
    const panelItems = this.state.panelData.map((item, idx) => {
      return (
        <QualityPanelItem
          key={idx}
          label={item.label}
          value={item.value}
          percentLabel={item.percentLabel}
          percentValue={item.percentValue}
          style={{border:'1px',solid:'black'}}
        />
      );
    });
 return (
      <div className="analytics-panel comparison">
        <div className="row">
          <div className="col-full">
            <div className="panel-box">
              {panelItems}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// The Summary page's stat strip fetches /quality/summarypanels directly
// (never through ReportPageChart), so the breadcrumb scope is attached here:
// scope_locations, enforced server-side by NextosReportBase._resolve_locations.
// The gate holds the first mount until the scope resolves, so the strip never
// fires an unscoped request.
const EMPTY_FILTERS = {};

const QualityTrendPanelsWithScope = (props) => {
  const { scope, apiFilters, hold, isEmptyIntersection } = useScopedApiFilters(
    EMPTY_FILTERS,
  );

  return (
    <LocationScopeGate scope={scope}>
      {hold ? (
        <DefaultSpinner />
      ) : isEmptyIntersection ? (
        <NoData />
      ) : (
        <QualityTrendPanels {...props} scopedFilters={apiFilters} />
      )}
    </LocationScopeGate>
  );
};

export default QualityTrendPanelsWithScope;
